import React from 'react';
import { ArrowRight, Cpu, Lightbulb, Calculator } from 'lucide-react';
import { AUTOMATION_ITEMS, IMAGES } from '../mock';

const ICONS = [Cpu, Lightbulb, Calculator];

export default function Automation() {
  return (
    <section id="automatyka" className="bg-[#f5f5f7] py-24 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="text-[12px] font-semibold tracking-[0.25em] text-[#0f1a2b]/60 mb-4">AUTOMATYKA PRZEMYSŁOWA</div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-6">
            <h2 className="font-heading font-extrabold text-[40px] md:text-[52px] leading-[1.05] tracking-tight text-[#0f1a2b]">Automatyka przemysłowa</h2>
            <p className="mt-6 text-[15px] leading-relaxed text-[#0f1a2b]/75 max-w-xl">
              Projektowanie, koncepcje, dobór rozwiązań oraz doradztwo techniczne dla maszyn, linii produkcyjnych i procesów technologicznych.
            </p>
            <div className="mt-8 rounded-2xl overflow-hidden">
              <img src={IMAGES.automation} alt="Zrobotyzowana linia produkcyjna" className="w-full h-[360px] object-cover" />
            </div>
            <a href="#kontakt" className="mt-8 inline-flex items-center gap-2 text-[#0f1a2b] font-semibold text-[15px] group">
              Omów projekt automatyki
              <ArrowRight className="h-4 w-4 text-[#f5c518] transition-transform group-hover:translate-x-1" />
            </a>
          </div>

          <div className="lg:col-span-6 space-y-5">
            {AUTOMATION_ITEMS.map((it, i) => {
              const Icon = ICONS[i];
              return (
                <div key={i} className="rounded-2xl bg-white border border-slate-200 p-7 hover-lift">
                  <div className="h-11 w-11 rounded-lg bg-[#132a44] flex items-center justify-center mb-5">
                    <Icon className="h-5 w-5 text-[#f5c518]" />
                  </div>
                  <h3 className="font-heading font-bold text-[19px] tracking-tight text-[#0f1a2b]">{it.title}</h3>
                  <p className="mt-3 text-[14px] leading-relaxed text-[#0f1a2b]/70">{it.desc}</p>
                  {it.tags && (
                    <div className="mt-4 flex flex-wrap gap-2">
                      {it.tags.map((t) => (
                        <span key={t} className="text-[12px] font-medium bg-[#f5f5f7] border border-slate-200 rounded-full px-3 py-1 text-[#0f1a2b]/80">{t}</span>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
